import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: localStorage.getItem('accessToken') || null,
  email: localStorage.getItem('userEmail') || null,
  expiresAt: localStorage.getItem('expiresAt') || null,
};

const accessTokenSlice = createSlice({
  name: 'accessToken',
  initialState,
  reducers: {
    setAccessToken(state, action) {
      state.token = action.payload;
      // Persist to localStorage
      if (action.payload) {
        localStorage.setItem('accessToken', action.payload);
      }
    },
    setEmail(state, action) {
      state.email = action.payload;
      if (action.payload) {
        localStorage.setItem('userEmail', action.payload);
      }
    },
    setExpiresAt(state, action) {
      state.expiresAt = action.payload;
      if (action.payload) {
        localStorage.setItem('expiresAt', action.payload);
      }
    },
    clearAccessToken(state) {
      state.token = null;
      state.email = null;
      state.expiresAt = null;
      // Clear from localStorage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('expiresAt');
    },
  },
});

export const { setAccessToken, setEmail, setExpiresAt, clearAccessToken } = accessTokenSlice.actions;
export default accessTokenSlice.reducer;